import React, { useState } from "react";
import Style from "./ImageWaterMark.module.scss";
import CommonModal from "../../components/Modals/CommonModal";
import Assets from "../../components/Layouts/Assets";
import { Slider } from "antd";
import { useWaterMark } from "./useWaterMark";
import InfiniteDotLoader from "../InfiniteDotLoader";

let positionData = [
  {
    label: "3x3 Matrix",
    value: "3-dimension",
    id: 1,
  },
  {
    label: "Center",
    value: "center",
    id: 3,
  },
  {
    label: "Right Corner",
    value: "right-corner",
    id: 2,
  },
];
const ImageWaterMark = ({ open, close, title }) => {
  let sampleUrl = "https://picsum.photos/seed/picsum/200/300";

  const {
    canvasRef,
    tempWatermark,
    option,
    fileName,
    opacity,
    waterMarkStatus,
    setOpacity,
    setWatermarkImage,
    handleChangeImage,
    handleChangeOpacity,
    handleChangePosition,
    handleSave,
    error,
  } = useWaterMark({ sampleUrl, open, close, positionData });

  return (
    <CommonModal
      backdrop="static"
      keyboard={false}
      showModal={open}
      setShowModal={() => close()}
      centered={true}
      className={`${Style.ImageWaterMark}`}
      title={<h4>{title}</h4>}
      content={
        <div className={`${Style.Image_container} row`}>
          <div className={`${Style.image_section} col-md-5`}>
            <canvas ref={canvasRef} />
            {/* <img src={sampleImage} ref={sampleRef} /> */}
          </div>
          <div className="col-md-7">
            <div className={`${Style.file_container}`}>
              <p className={`${Style.heading}`}>Upload water mark</p>
              <div className={`${Style.file_section} flex`}>
                <div className={`${Style.file_name} col-md-7 ps-4`}>
                  {fileName}
                </div>
                <div className={`${Style.file_button} col-md-5 px-2`}>
                  <label htmlFor="uploadImg">
                    <p>Choose File</p>
                    <input
                      type="file"
                      className="d-none"
                      id="uploadImg"
                      accept=".png"
                      name="name-profile"
                      onChange={handleChangeImage}
                    />
                  </label>
                </div>
              </div>
              {error != "" && <p className={Style.fileSizeError}>{error}</p>}
            </div>

            <div className={`${Style.file_container}`}>
              <p className={`${Style.heading}`}>Opacity</p>
              <div className={`${Style.file_section} flex flex-wrap ps-4`}>
                <div className={`${Style.file_slider} col-md-8`}>
                  <div className={`${Style.slider}`}>
                    <input
                      type="range"
                      min="0"
                      max="100"
                      value={opacity}
                      onChange={handleChangeOpacity}
                    />
                  </div>
                </div>
                <div className={`${Style.file_button} col-md-4`}>
                  <p>{localStorage.getItem("watermark_opacity")}%</p>
                </div>
              </div>
            </div>

            <div className={`${Style.file_container}`}>
              <p className={`${Style.heading}`}>Watermark position</p>
              <div className={`${Style.selection}`}>
                {positionData?.map((item, index) => {
                  return (
                    <div key={index} className={`${Style.item}`}>
                      <input
                        type="radio"
                        id={item?.value}
                        checked={option?.value == item?.value}
                        onChange={() => handleChangePosition(item)}
                      />
                      <label for={item.value}>{item.label}</label>
                    </div>
                  );
                })}
              </div>
            </div>

            <div className={`${Style.actions}`}>
              <button
                className="btn btn-border-grey px-4 mx-2"
                onClick={() => close()}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary px-4"
                onClick={() => handleSave()}
              >
                {waterMarkStatus == "loading" ? (
                  <InfiniteDotLoader />
                ) : (
                  "Upload"
                )}
              </button>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default ImageWaterMark;
